module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/all-promos-7bd6efc78aaada4eaffba30656e7b318.jpg";